import DraggableFocusItemCard from 'pages/focusItems/components/DraggableFocusItemCard'
import ScrollLayoutDynamicArrow from '../../../../components/ScrollLayoutDynamicArrow'
import { capitalizeFirstLetter } from '../../../../helpers/stringHelper'
import {
  FOCUS_ARROW_HIDDEN_TYPE,
  FOCUSED_HORIZONTAL_OPTIMAL_HEIGHT,
  MIN_HORIZONTAL_ITEMS,
} from '../../../focusItems/enums'

export function FocusedHorizontalList({
  aspectRatio,
  heightFactor,
  data,
  mobile,
  arrow,
  hasTitles = false,
  findCard,
  moveCard,
  allowDrag,
  onUpdateFocusItem,
  handleDrop,
  processing,
}) {
  const _data = data ?? []
  return (
    <ScrollLayoutDynamicArrow
      isNavOverlay={arrow === FOCUS_ARROW_HIDDEN_TYPE[1].value}
      className={`horizontal-list${mobile ? ' space-x-2.5' : ' sm:space-x-3'}`}
      showNav={!mobile && arrow !== FOCUS_ARROW_HIDDEN_TYPE[2].value}
      classNav="mx-8 blog-nav"
    >
      {Array.from({ length: _data?.length }, (_, i) => {
        const item = _data[i] ?? {}
        return allowDrag ? (
          <DraggableFocusItemCard
            key={item.id}
            dragId={item.id}
            findCard={findCard}
            moveCard={moveCard}
            showDragHandle={data?.length > 1}
            onDrop={allowDrag && onUpdateFocusItem ? handleDrop : undefined}
            dragHandleOnly={false}
            dragDisabled={!allowDrag || processing}
          >
            <FocusedHorizontalListItem
              item={item}
              aspectRatio={aspectRatio}
              heightFactor={heightFactor}
              mobile={mobile}
              hasTitles={hasTitles}
            />
          </DraggableFocusItemCard>
        ) : (
          <FocusedHorizontalListItem
            item={item}
            aspectRatio={aspectRatio}
            heightFactor={heightFactor}
            mobile={mobile}
            hasTitles={hasTitles}
          />
        )
      })}
    </ScrollLayoutDynamicArrow>
  )
}

function FocusedHorizontalListItem({
  item,
  aspectRatio,
  heightFactor,
  mobile,
  hasTitles = false,
}) {
  return (
    <div
      key={`list-horizontal-${item.id}`}
      className={`${hasTitles ? (mobile ? 'bg-white pb-[52px]' : 'bg-white sm:pb-[73px]') : ''} app-rounded relative`}
    >
      <div
        style={{
          ...(aspectRatio && {
            aspectRatio: `${aspectRatio}`,
            height: `${FOCUSED_HORIZONTAL_OPTIMAL_HEIGHT * (heightFactor ?? 1)}px`,
            overflow: 'hidden',
          }),
        }}
      >
        <img
          className={`object-cover w-full h-full app-rounded`}
          src={mobile ? item.image_url : item.image_url_web}
          alt={item.title}
        />
      </div>

      {hasTitles && (
        <div
          className={`${mobile ? 'h-[55px] py-2.5 px-2' : 'sm:h-[72px] p-3'} flex flex-col items-center justify-center text-center bg-white absolute bottom-0 left-0 right-0 z-negative`}
        >
          {item.title && (
            <div className="font-bold leading-snug truncate text-secondaryApp w-full">
              {capitalizeFirstLetter(item.title)}
            </div>
          )}
          {item.sub_title && (
            <div className="text-xs leading-none truncate text-rand-100 w-full">
              {capitalizeFirstLetter(item.sub_title)}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export function FocusedHorizontalListLoader({
  arrow,
  aspectRatio,
  length,
  heightFactor,
  mobile,
  hasTitles = false,
}) {
  return (
    <div className="animate-pulse">
      <ScrollLayoutDynamicArrow
        isNavOverlay={arrow === FOCUS_ARROW_HIDDEN_TYPE[1].value}
        className={`horizontal-list${mobile ? ' space-x-2.5' : ' sm:space-x-3'}`}
        showNav={!mobile && arrow !== FOCUS_ARROW_HIDDEN_TYPE[2].value}
        isDefaultVisible={false}
        classNav="mx-8 blog-nav"
      >
        {Array.from({ length: length ?? MIN_HORIZONTAL_ITEMS }, (_, i) => (
          <div key={`loader-horizontal-${i}`}>
            <div
              className={`bg-loader`}
              style={{
                ...(aspectRatio && { aspectRatio: `${aspectRatio}` }),
                height: `${FOCUSED_HORIZONTAL_OPTIMAL_HEIGHT * (heightFactor ?? 1)}px`,
              }}
            />
            {hasTitles && (
              <div className="text-center bg-white p-2">
                <div className="h-3 bg-loader mb-1">&nbsp;</div>
                <div className="h-3 bg-loader">&nbsp;</div>
              </div>
            )}
          </div>
        ))}
      </ScrollLayoutDynamicArrow>
    </div>
  )
}
